var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CompanyPlans'),_c('v-divider'),_c('CompanyTransactions',{staticClass:"mt-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }